import gql from "graphql-tag";
import { useCurrencies } from "@zapier/currency";
import { useCurrentAccountId } from "@zapier/promotions/esm/hooks";
import { useQuery as defaultUseQuery } from "@apollo/react-hooks";
export const accountCurrencyQuery = gql `
  query accountCurrencyQuery($accountId: Int!) {
    account(id: $accountId) {
      id
      currency
    }
  }
`;
export const useAccountCurrency = (props) => {
    const useQuery = (props === null || props === void 0 ? void 0 : props.useQuery) || defaultUseQuery;
    const { accountId } = useCurrentAccountId(props);
    const { currencies, isLoading: isCurrenciesLoading } = useCurrencies({
        useQuery,
    });
    const { data, error, loading } = useQuery(accountCurrencyQuery, {
        skip: !accountId,
        variables: { accountId },
    });
    return {
        currency: currencies === null || currencies === void 0 ? void 0 : currencies.find((c) => { var _a; return c.name === ((_a = data === null || data === void 0 ? void 0 : data.account) === null || _a === void 0 ? void 0 : _a.currency); }),
        error: error ? "There was an issue loading data." : undefined,
        isLoading: loading || isCurrenciesLoading,
    };
};

// @zapier/upsells@5.0.1 (c64b11b3c)
